/* Take Action campaign page.
 * Vanilla JS, no dependencies. Everything is progressive enhancement:
 * with JS disabled the page still renders fully, links still work.
 * GA4 events go through the theme's existing GTM dataLayer. */
(function () {
  'use strict';

  var root = document.getElementById('ta-page');
  if (!root) return;

  /* Suppress cart-drawer AUTO-open on this template only. The drawer's
   * renderContents() calls open() after any cart refresh, which apps can
   * trigger without the visitor doing anything. Gate open() behind a recent
   * user interaction so tapping the header cart icon still works normally. */
  (function guardCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') {
      /* custom element may not be upgraded yet */
      if (!guardCartDrawer.retried) {
        guardCartDrawer.retried = true;
        window.addEventListener('load', guardCartDrawer);
      }
      return;
    }
    var lastInteraction = 0;
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (type) {
      document.addEventListener(
        type,
        function () {
          lastInteraction = Date.now();
        },
        { capture: true, passive: true }
      );
    });
    var originalOpen = drawer.open.bind(drawer);
    drawer.open = function (triggeredBy) {
      if (Date.now() - lastInteraction > 1500) return;
      originalOpen(triggeredBy);
    };
  })();

  function track(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (params) {
      for (var key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) payload[key] = params[key];
      }
    }
    window.dataLayer.push(payload);
  }

  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var helper = document.createElement('textarea');
      helper.value = text;
      helper.setAttribute('readonly', '');
      helper.style.position = 'fixed';
      helper.style.opacity = '0';
      document.body.appendChild(helper);
      helper.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      }
      document.body.removeChild(helper);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      /* Some in-app browsers reject writeText despite a secure context; fall back. */
      return navigator.clipboard.writeText(text).catch(function () {
        return legacyCopy(text);
      });
    }
    return legacyCopy(text);
  }

  function flashLabel(button, timerRef) {
    var original = button.getAttribute('data-ta-label') || button.textContent;
    button.setAttribute('data-ta-label', original);
    button.textContent = button.getAttribute('data-ta-copied-label') || 'Copied';
    button.classList.add('is-copied');
    clearTimeout(timerRef.id);
    timerRef.id = setTimeout(function () {
      button.textContent = original;
      button.classList.remove('is-copied');
    }, 2000);
  }

  /* Click tracking on tap targets */
  root.addEventListener('click', function (event) {
    var el = event.target.closest('[data-ta-event]');
    if (!el) return;
    var name = el.getAttribute('data-ta-event');
    if (name === 'sms') {
      track('take_action_sms_click', { link_location: el.getAttribute('data-ta-location') || 'step_1' });
    } else if (name === 'call') {
      track('take_action_call_click');
    } else if (name === 'flyer') {
      track('take_action_flyer_download', { flyer_state: el.getAttribute('data-ta-state') || '' });
    }
  });

  /* Copy-script button */
  var copyButton = root.querySelector('[data-ta-copy]');
  var copySource = root.querySelector('[data-ta-copy-source]');
  if (copyButton && copySource) {
    var copyTimer = { id: null };
    copyButton.addEventListener('click', function () {
      copyText(copySource.textContent.trim()).then(function () {
        flashLabel(copyButton, copyTimer);
        track('take_action_copy_script');
      });
    });
  }

  /* Share modal mirrors the article-page sharing experience. */
  var shareButton = root.querySelector('[data-ta-share-open]');
  var shareModal = root.querySelector('[data-ta-share-modal]');
  if (shareButton && shareModal) {
    var shareCloseButtons = shareModal.querySelectorAll('[data-ta-share-close]');
    var shareCopyButton = shareModal.querySelector('[data-ta-share-copy]');
    var shareUrl = shareModal.getAttribute('data-share-url') || window.location.href;
    var copiedTimeout = null;

    function setShareCopied(isCopied) {
      if (!shareCopyButton) return;
      shareCopyButton.classList.toggle('is-copied', isCopied);
      if (!isCopied) return;
      clearTimeout(copiedTimeout);
      copiedTimeout = setTimeout(function () {
        shareCopyButton.classList.remove('is-copied');
      }, 1800);
    }

    function openShareModal() {
      if (!shareModal.hidden) return;
      setShareCopied(false);
      shareModal.hidden = false;
      window.requestAnimationFrame(function () {
        shareModal.classList.add('is-open');
      });
      document.body.classList.add('ta-share-modal-open');
      var closeButton = shareModal.querySelector('[data-ta-share-close]');
      if (closeButton) closeButton.focus();
    }

    function closeShareModal() {
      if (shareModal.hidden) return;
      shareModal.classList.remove('is-open');
      setTimeout(function () {
        if (!shareModal.classList.contains('is-open')) shareModal.hidden = true;
      }, 260);
      document.body.classList.remove('ta-share-modal-open');
      shareButton.focus();
    }

    function copyShareUrl() {
      copyText(shareUrl).then(function () {
        setShareCopied(true);
        track('take_action_share', { share_method: 'copy' });
      });
    }

    shareButton.addEventListener('click', openShareModal);
    shareCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeShareModal);
    });

    shareModal.addEventListener('click', function (event) {
      var actionTarget = event.target.closest('[data-ta-share-action]');
      if (!actionTarget) return;
      var action = actionTarget.getAttribute('data-ta-share-action');

      if (action === 'copy') {
        event.preventDefault();
        copyShareUrl();
      } else if (action === 'instagram') {
        event.preventDefault();
        copyShareUrl();
        window.open('https://www.instagram.com/', '_blank', 'noopener');
      } else {
        track('take_action_share', { share_method: action });
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !shareModal.hidden) closeShareModal();
    });
  }

  /* Sticky SMS bar: slides in once the step-1 card is scrolled past (touch only, CSS-gated) */
  var sticky = root.querySelector('[data-ta-sticky]');
  var stickyAnchor = root.querySelector('[data-ta-sticky-anchor]');
  if (sticky && stickyAnchor && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-active', scrolledPast);
    });
    stickyObserver.observe(stickyAnchor);
  }

  /* Scroll reveals: class is only added when JS runs, so no-JS keeps content visible */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealTargets = root.querySelectorAll('[data-ta-reveal]');
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealTargets.forEach(function (el) {
      el.classList.add('ta-reveal');
      revealObserver.observe(el);
    });
  }
})();
